import { render } from "./PTable.vue?vue&type=template&id=51988119&scoped=true"
import script from "./PTable.vue?vue&type=script&lang=js"
export * from "./PTable.vue?vue&type=script&lang=js"

import "./PTable.vue?vue&type=style&index=0&id=51988119&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51988119"]])

export default __exports__